/* ✦ KHENO Y2K ✦ — petites interactions */
(function () {
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* 1. Pluie d'étoiles au clic sur "Ajouter au panier" */
  var COLORS = ['#ff5fc8', '#b69cff', '#24c6ff', '#7fe7ff', '#ffd23f'];
  function burst(x, y) {
    if (reduceMotion || !document.body.animate) return;
    for (var i = 0; i < 14; i++) {
      var s = document.createElement('span');
      s.className = 'kheno-spark';
      s.textContent = i % 3 === 0 ? '✧' : '✦';
      s.style.left = x + 'px';
      s.style.top = y + 'px';
      s.style.color = COLORS[i % COLORS.length];
      s.style.fontSize = 12 + Math.random() * 14 + 'px';
      document.body.appendChild(s);
      var angle = (Math.PI * 2 * i) / 14 + Math.random() * 0.4;
      var dist = 50 + Math.random() * 60;
      var anim = s.animate(
        [
          { transform: 'translate(-50%,-50%) scale(.4) rotate(0deg)', opacity: 1 },
          {
            transform:
              'translate(calc(-50% + ' + Math.cos(angle) * dist + 'px), calc(-50% + ' + Math.sin(angle) * dist + 'px)) scale(1) rotate(' +
              (Math.random() * 180 - 90) + 'deg)',
            opacity: 0
          }
        ],
        { duration: 700 + Math.random() * 300, easing: 'cubic-bezier(.2,.7,.3,1)' }
      );
      anim.onfinish = (function (el) { return function () { el.remove(); }; })(s);
    }
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.add-to-cart-button, button[name="add"]');
    if (!btn || btn.disabled) return;
    var r = btn.getBoundingClientRect();
    burst(e.clientX || r.left + r.width / 2, e.clientY || r.top + r.height / 2);
  });

  /* 2. Jauge "offre de Noël" qui suit la quantité choisie */
  function fmt(cents, cur) {
    try {
      return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: cur || 'EUR' }).format(cents / 100);
    } catch (err) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }
  }
  function initMeters() {
    var meters = document.querySelectorAll('[data-kheno-meter]');
    if (!meters.length) return;
    var last = null;
    function update() {
      var input = document.querySelector('.product-details input[name="quantity"], product-form-component input[name="quantity"], input[name="quantity"]');
      var qty = Math.max(1, parseInt(input && input.value, 10) || 1);
      if (qty === last) return;
      last = qty;
      meters.forEach(function (m) {
        var price = parseInt(m.getAttribute('data-price'), 10) || 0;
        var cur = m.getAttribute('data-currency') || 'EUR';
        var pct = qty >= 3 ? 25 : qty === 2 ? 15 : 0;
        var full = price * qty;
        var total = Math.round(full * (100 - pct) / 100);
        var msg;
        if (qty >= 3) msg = '🎉 -25 % débloqué ! Le max de l’offre.';
        else if (qty === 2) msg = '🔥 -15 % débloqué ! Encore 1 montre pour -25 %.';
        else msg = '✦ Ajoute 1 montre (n’importe quelle couleur) pour -15 %.';
        m.querySelector('[data-kheno-meter-msg]').textContent = msg;
        m.querySelector('[data-kheno-meter-fill]').style.width = Math.min(qty, 3) / 3 * 100 + '%';
        var priceEl = m.querySelector('[data-kheno-meter-price]');
        if (price) {
          priceEl.innerHTML = pct
            ? '<s>' + fmt(full, cur) + '</s> <strong>' + fmt(total, cur) + '</strong> pour ' + qty + ' montres'
            : '<strong>' + fmt(full, cur) + '</strong> pour 1 montre';
        }
        m.classList.toggle('is-unlocked', pct > 0);
        m.hidden = false;
        if (pct > 0 && !reduceMotion) {
          m.classList.remove('is-pop');
          void m.offsetWidth;
          m.classList.add('is-pop');
        }
      });
    }
    update();
    document.addEventListener('input', update, true);
    document.addEventListener('change', update, true);
    document.addEventListener('click', function () { setTimeout(update, 60); }, true);
    setInterval(function () { if (!document.hidden) update(); }, 500);
  }

  /* 3. Effet 3D sur les photos produit (ordinateur) */
  function initTilt() {
    if (reduceMotion || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    var imgs = document.querySelectorAll('.product-information img');
    imgs.forEach(function (img) {
      if (img.closest('.kheno-pay, .kheno-rmini') || img.width < 200) return;
      var box = img.parentElement;
      box.classList.add('kheno-tilt');
      box.addEventListener('mousemove', function (e) {
        var r = box.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width - 0.5;
        var py = (e.clientY - r.top) / r.height - 0.5;
        box.style.transform = 'perspective(900px) rotateY(' + px * 8 + 'deg) rotateX(' + -py * 8 + 'deg) scale(1.02)';
        box.style.setProperty('--kx', (px + 0.5) * 100 + '%');
        box.style.setProperty('--ky', (py + 0.5) * 100 + '%');
      });
      box.addEventListener('mouseleave', function () { box.style.transform = ''; });
    });
  }

  /* 4. Apparition douce des blocs au scroll */
  function initReveal() {
    if (reduceMotion || !('IntersectionObserver' in window)) return;
    var els = document.querySelectorAll('.kheno-reas__item, .kheno-faq__item, .kheno-duo__card, .kheno-duo__tier, .kheno-rmini__item');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('kheno-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12 });
    els.forEach(function (el, i) {
      el.classList.add('kheno-reveal');
      el.style.transitionDelay = (i % 6) * 60 + 'ms';
      io.observe(el);
    });
  }

  function init() { initMeters(); initTilt(); initReveal(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
